import { useState } from "react";
import { Icons } from "../assets/icons/Icons";

const PhoneInput = ({
    label = "PHONE NUMBER",
    value = "",
    onChange,
    countryCode = "US",
    onCountryChange,
    active = false,
    bgType = "gray",
    className = "",
    labelClassName = "mb-1 font-600",
    inputClassName = "form-control form-control-lg border-0 text-white rounded-3 ps-5",
    ...props
}) => {
    // Determine background color based on bgType
    let bgColor = "#000000"; // Default black
    if (bgType === "dark") bgColor = "#141414";
    if (bgType === "gray") bgColor = "#1E1E1E";

    // Common country codes for dropdown
    const [showDropdown, setShowDropdown] = useState(false);
    const countries = [
        { code: "US", name: "United States", dialCode: "+1" },
        { code: "GB", name: "United Kingdom", dialCode: "+44" },
        { code: "CA", name: "Canada", dialCode: "+1" },
        { code: "AU", name: "Australia", dialCode: "+61" },
        { code: "DE", name: "Germany", dialCode: "+49" },
        { code: "FR", name: "France", dialCode: "+33" },
        { code: "JP", name: "Japan", dialCode: "+81" },
        { code: "CN", name: "China", dialCode: "+86" },
        { code: "IN", name: "India", dialCode: "+91" },
        { code: "BR", name: "Brazil", dialCode: "+55" },
    ];

    const handleCountrySelect = (code) => {
        if (onCountryChange) {
            onCountryChange(code);
        }
        setShowDropdown(false);
    };

    return (
        <div className={`mb-4 ${className}`}>
            {label && (
                <label
                    className={labelClassName}
                    style={{ color: "#797373", fontSize: "10px" }}
                >
                    {label}
                </label>
            )}
            <div className="position-relative">
                {/* Country Code Selector */}
                <div
                    className="d-flex justify-content-between align-items-center position-relative rounded-3 px-3"
                    style={{
                        direction: "row",
                        backgroundColor: bgColor,
                        ...props.style,
                    }}
                >
                    <div
                        className="  d-flex "
                        style={{
                            zIndex: 10,
                            cursor: "pointer",
                            height: "auto",
                        }}
                        onClick={() => setShowDropdown(!showDropdown)}
                    >
                        <img
                            src={`https://flagcdn.com/w20/${countryCode.toLowerCase()}.png`}
                            alt="Country flag"
                            style={{
                                width: "32px",
                                height: "21px",
                                marginRight: "10px",
                                borderRadius: 4,
                            }}
                        />
                        <span className="text-white">▼</span>
                    </div>

                    {/* Phone Input */}
                    <input
                        type="tel"
                        className="border-0"
                        value={value}
                        onChange={onChange}
                        style={{
                            height: "50px",
                            marginLeft: "10px",
                            marginRight: "10px",
                            width: "-webkit-fill-available",
                            border: "none",
                            outline: "none",
                            color: "#fff",
                            backgroundColor: bgColor,
                        }}
                        {...props}
                    />

                    {/* Active Checkmark */}
                    {active && (
                        <div className=" ">
                            <Icons.ActiveCkeckMarkIcon />
                        </div>
                    )}
                </div>

                {/* Country Dropdown */}
                {showDropdown && (
                    <div
                        className="position-absolute start-0 mt-1 rounded-3 py-2"
                        style={{
                            backgroundColor: "#1E1E1E",
                            width: "100%",
                            maxHeight: "200px",
                            overflowY: "auto",
                            zIndex: 100,
                            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                        }}
                    >
                        {countries.map((country) => (
                            <div
                                key={country.code}
                                className="d-flex align-items-center px-3 py-2"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                    handleCountrySelect(country.code)
                                }
                            >
                                <img
                                    src={`https://flagcdn.com/w20/${country.code.toLowerCase()}.png`}
                                    alt={country.name}
                                    style={{
                                        width: "24px",
                                        marginRight: "12px",
                                    }}
                                />
                                <span className="text-white">
                                    {country.name}
                                </span>
                                <span className="text-secondary ms-auto">
                                    {country.dialCode}
                                </span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PhoneInput;
